import React, { useEffect, useRef } from 'react';

import { block } from 'bem-cn';

import Typography from '../Typography';

import './miniTag.scss';

const b = block('minitag');

const VARIANTS = {
  DEFAULT: 'default',
  PASSIVE: 'passive',
  DATE: 'date',
  DUE: 'due',
  Overdue: 'overdue',
};

type MiniTagPropsType = {
  tag: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onWidth?: (width: number, tag: string) => any;
  processFlag?: boolean;
  hidden?: boolean;
  variant?: string;
};

const MiniTag = ({
  tag,
  onClick,
  onWidth,
  processFlag,
  hidden,
  variant = VARIANTS.DEFAULT,
}: MiniTagPropsType) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const width = ref.current ? ref.current.offsetWidth : 0;
    if (processFlag && onWidth) onWidth(width, tag);
  }, [ref.current]);

  return (
    <div
      className={b({ clickable: !!onClick, [variant]: true })}
      ref={ref}
      style={{ visibility: hidden ? 'hidden' : 'visible' }}
      onClick={onClick}
    >
      <Typography
        component='span'
        variant={Typography.THEME.VARIANTS.CARD_TAG_MICRO}
      >
        {tag}
      </Typography>
    </div>
  );
};

export default MiniTag;
